import style from "./DemoPage.module.css";

const DemoPage = () => {
   return (
    <div className={style.demo}>
         Hello I Am Demo Page
    </div>  
  )
}

export default DemoPage ;